export default __webpack_public_path__ + "static/media/mob_home_icon.36363833.svg";